import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import React from "react";

const Footer: React.FC = () => {
    return (
        <footer className="container-fluid border-top mt-4 py-4" style={{backgroundColor:'#F7F7F7'}}>
            <div className="row align-items-start justify-content-center">
                {/* Left Section */}
                <div className="col-md-6 d-flex flex-column">
                    <img
                        src="/logo.png"
                        alt="B-yond Client Pulse Logo"
                        style={{ width: '150px', marginRight: '16px' }}
                    />
                    <div>
                        <p className="mb-1 mt-2" style={{fontSize:'12px'}}>Upload your audio, and let our AI do the work.</p>
                        <p className="mb-1 mt-1" style={{fontSize:'12px'}}>Get high-quality transcriptions with speaker recognition, summaries, and insights.</p>
                    </div>
                </div>

                {/* Right Section */}
                <div className="col-md-5 text-md-end mt-3">
                    <div className="d-flex flex-column justify-content-center">
                    <h6  style={{fontSize:'14px'}}>
                        Email:
                        <a href="mailto:support@beyondigital.com" className="text-danger">
                            support@byonddigital.com
                        </a>
                    </h6>
                    <div className="flex justify-end space-x-3 mt-2">
                        <a href="#"><FaFacebookF size={25}  className="text-black border rounded-full p-1 h-6 w-6" /></a>
                        <a href="https://www.linkedin.com/company/b-yond-digital-technologies"><FaLinkedinIn size={25} className="text-black border rounded-full p-1 h-6 w-6" /></a>
                    </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;